import React from 'react';
import { Box, Stack, Typography, TextField } from '@mui/material';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { formatDate } from '../../../../services/functions';
import { SmallFormTextField } from '../../../../components-core/small-fields/SmallFormTextField';

export const ContactDataForm = props => {
  const { formik, type, name, streetAddress, postalCode, city, birthDate, nipOrPesel, phoneNumber, email, invoice, gender } = props;

  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1}>
      <Stack spacing={1} flex="1 1 50%">
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Nazwa</Typography>
          <SmallFormTextField
            error={formik.errors[name] && formik.touched[name]}
            name={name}
            placeholder="nazwa"
            value={formik.values[name]}
            onChange={formik.handleChange}
            helperText={formik.errors[name]}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Adres</Typography>
          <SmallFormTextField
            error={formik.errors[streetAddress] && formik.touched[streetAddress]}
            name={streetAddress}
            placeholder="ulica"
            value={formik.values[streetAddress]}
            onChange={formik.handleChange}
            helperText={formik.errors[streetAddress]}
          />
        </Stack>
        {/* <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Kod pocztowy</Typography>
          <SmallFormTextField
            error={formik.errors[postalCode] && formik.touched[postalCode]}
            name={postalCode}
            placeholder="kod pocztowy"
            value={formik.values[postalCode]}
            onChange={formik.handleChange}
            helperText={formik.errors[postalCode]}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Miejscowość</Typography>
          <SmallFormTextField
            error={formik.errors[city] && formik.touched[city]}
            name={city}
            placeholder="miejscowość"
            value={formik.values[city]}
            onChange={formik.handleChange}
            helperText={formik.errors[city]}
          />
        </Stack> */}
      </Stack>

      <Stack spacing={1} flex="1 1 50%">
        {/* { type === 'participant' ? (
          <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
            <Typography variant="subtitle2">Data urodzenia</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                name={birthDate}
                inputFormat="yyyy-MM-dd"
                mask="____-__-__"
                label="data urodzenia"
                value={formik.values[birthDate]}
                onChange={val => formik.setFieldValue(birthDate, formatDate(val))}
                renderInput={params => <TextField size="small" sx={{ width: '60%' }} {...params} />}
              />
            </LocalizationProvider>
          </Stack>)
          : null
        } */}
        { type !== 'guardian'
          ? <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
            <Typography variant="subtitle2">{type === 'participant' ? 'PESEL' : 'NIP'}</Typography>
            <SmallFormTextField name={nipOrPesel} placeholder={type === 'participant' ? 'pesel' : 'nip'} value={formik.values[nipOrPesel]} onChange={formik.handleChange} />
          </Stack>
          : null}
        { type !== 'participant' ? (
          <>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Telefon</Typography>
              <SmallFormTextField name={phoneNumber} placeholder="telefon" value={formik.values[phoneNumber]} onChange={formik.handleChange} />
            </Stack><Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">E-mail</Typography>
              <SmallFormTextField
                error={formik.errors[email] && formik.touched[email]}
                name={email}
                placeholder="e-mail"
                value={formik.values[email]}
                onChange={formik.handleChange}
                helperText={formik.errors[email]}
              />
            </Stack>
          </>)
          : null
        }
        {type === 'participant'
          ? <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
            <Typography variant="subtitle2">Miejsce pracy lub nauki</Typography>
            <SmallFormTextField
              error={formik.errors.job_or_scholl_address && formik.touched.job_or_scholl_address}
              name="job_or_scholl_address"
              placeholder="miejsce pracy lub naukil"
              value={formik.values.job_or_scholl_address}
              onChange={formik.handleChange}
              helperText={formik.errors.job_or_scholl_address}
            />
          </Stack>
          : null}
        {/* { type === 'contractor' ? (
          <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
            <Typography variant="subtitle2">Faktura</Typography>
            <SmallFormTextField name={invoice} placeholder="faktura" value={formik.values[invoice]} onChange={formik.handleChange} />
          </Stack>)
          : null
        } */}
        {/* { type === 'participant' ? (
          <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
            <Typography variant="subtitle2">Płeć</Typography>
            <SmallFormTextField
              select
              name={gender}
              placeholder="płeć"
              options={[{ value: 'boy', label: 'Chłopiec' }, { value: 'girl', label: 'Dziewczynka' }]}
              value={formik.values[gender]}
              onChange={formik.handleChange} />
          </Stack>)
          : null
        } */}
      </Stack>
    </Box>
  );
};
